import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const headerWrapper = css`
  padding: ${spacing.sm}px;
  border-left: 3px solid transparent;

  &[aria-checked='mixed'] {
    border-left-color: var(--brand-purple-base);
  }

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      border-left: none;
      padding: ${spacing.sm}px 0;
    `,
  )};

  h4 {
    margin: 0;
    font-size: 16px;
    line-height: 28px;
    font-weight: 600;
    text-transform: capitalize;
  }

  &[aria-hidden='true'] > h4 {
    color: var(--neutral-black-40);
  }

  h5 {
    margin: 0;
    ${responsiveText.BODY.SM};
    font-weight: 400;
    color: var(--brand-purple-base);
  }
`;

export const count = css`
  ${responsiveText.BODY.MD};
  font-weight: 400;
  color: var(--brand-purple-base);
  padding-left: ${spacing.base}px;
`;
